import { API_LOCATION_URL } from 'infrastructure/config';
import { IGetInput, IGetResponse, IBuyerSurveyClient } from 'interfaceAdapter/gatewaySchemas/IBuyerSurveyClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class BuyerSurveyClient implements IBuyerSurveyClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, matchId } = input;
        const PATH = `${API_LOCATION_URL}/buyer/survey?match_id=${matchId}`;
        const method = 'GET';

        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
